import moment from 'moment-timezone';
import { getTimezoneLabel } from 'stageclip-common';

export const DATE_READABLE_FORMAT = 'DD/MM/YYYY HH:mm Z';
export const DATE_READABLE_LONG_FORMAT = 'LLL';

function parsedDate(date: string, timezone?: string) {
  let result = moment(date);

  if (timezone) {
    result = result.tz(timezone);
  }

  return result;
}

export function sortableDateFormat(date: string, timezone?: string) {
  return parsedDate(date, timezone).toISOString();
}

export function readableDateFormat(date: string, timezone?: string) {
  return parsedDate(date, timezone).format(DATE_READABLE_FORMAT);
}

export function relativeDateFormat(date: string, timezone?: string) {
  const computedDate = parsedDate(date, timezone);

  return `${computedDate.calendar()} ${computedDate.format('Z z')}`;
}

export function isDifferentTimezone(date: string, timezone: string): boolean {
  return moment.tz(date, timezone).toString() !== moment.tz(date, moment.tz.guess()).toString();
}

export function getUserTimezone() {
  return moment.tz.guess();
}

export const formatTimezoneLabel = (timezone: string) =>
  `(UTC${moment.tz(timezone).format('Z')}) ${getTimezoneLabel(timezone)}`;
